import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { axios } from '../api';
import { Dropdown } from '../component/Dropdown';
import { TextInput } from '../component/TextInput';
import { TextInputMultiLine } from '../component/TextInputMultiLine';
import { Button } from '../component/buttons/Button';
import { GitHubRepos } from '../dropdownOptions';
import { BOTTOM_TOAST, generateErrorMsg } from '../utils';

export const FetchAi = () => {
  const [selectedGitHubRepo, setSelectedGitHubRepo] = React.useState(GitHubRepos[0]);
  const [jiraTicket, setJiraTicket] = React.useState('');
  const [acceptanceCriteria, setAcceptanceCriteria] = React.useState('');
  const [requiredFieldsAreValid, setRequiredFieldsAreValid] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const navigate = useNavigate();
  React.useEffect(() => {
    const isValid = jiraTicket.startsWith('SWE-') && acceptanceCriteria.length > 10;
    setRequiredFieldsAreValid(isValid);
  }, [jiraTicket, acceptanceCriteria]);

  const buttonLabel = isSubmitting ? 'Generating Pull Request...' : 'Generate Pull Request';

  const handleSubmit = () => {
    setIsSubmitting(true);

    axios
      .post('/generate_pr', {
        repo: selectedGitHubRepo.value,
        jira_ticket: jiraTicket,
        acceptance_criteria: acceptanceCriteria,
      })
      .then((res) => {
        const toastMsg = `Successfully submitted request. The FETCH AI agent will begin working shortly`;
        toast.success(toastMsg, BOTTOM_TOAST);
        const agentId = res.data.agent_id;

        navigate(`/fetch-ai/${agentId}`);
      })
      .catch((e) => {
        toast.error(generateErrorMsg(e), BOTTOM_TOAST);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="min-h-[calc(100vh-77px)] bg-slate50 p-8">
      <div className="mx-auto w-full max-w-4xl">
        <h1 className="mb-6 text-2xl font-semibold">FETCH AI</h1>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="flex flex-col">
            <div className="flex items-center gap-3">
              <div className="flex-1">
                <TextInput
                  value={jiraTicket}
                  setTextChange={setJiraTicket}
                  placeholder="e.g., SWE-1234"
                  bottomText="Jira ticket*"
                />
              </div>
            </div>

            <span className="mt-1 md:hidden text-xs text-slate-500">Enter a Jira key or link</span>
          </div>

          <Dropdown
            options={GitHubRepos}
            selectedOption={selectedGitHubRepo}
            setSelectedOption={setSelectedGitHubRepo}
            bottomText="Select GitHub repo*"
          />
        </div>

        <div className="mt-4">
          <TextInputMultiLine
            value={acceptanceCriteria}
            setTextChange={setAcceptanceCriteria}
            placeholder="Please write clear, testable acceptance criteria..."
            bottomText="Acceptance Criteria*"
            rows={10}
            minRows={6}
            maxRows={18}
            autoGrow
          />
        </div>
        <Button
          isDisabled={!requiredFieldsAreValid || isSubmitting}
          label={buttonLabel}
          onClick={handleSubmit}
          className="mt-6 w-full px-6 py-3"
        />
      </div>
    </div>
  );
};
